// extracted by mini-css-extract-plugin
export var closeButton = "_hw-1";
export var closeX = "_hw-3";
export var container = "_hw-0";
export var image = "_hw-2";